import { render, staticRenderFns } from "./project.vue?vue&type=template&id=8c1a13d2&scoped=true"
var script = {}
import style0 from "./project.vue?vue&type=style&index=0&id=8c1a13d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1a13d2",
  null
  
)

export default component.exports